import { useCallback, useEffect, useState } from "react";
import { listTasks, taskStats } from "../../api/tasks";
import { listBranches, listUsers } from "../../api/directory";

const EMPTY = { q: "", assignee_id: "", branch_id: "", priority: "", status: "" };

// كل بيانات صفحة المهام في مكان واحد: الفلاتر + القائمة + الإحصاءات + القوائم المرجعية.
export const useTasks = () => {
  const [filters, setFilters] = useState(EMPTY);
  const [rows, setRows] = useState([]);
  const [stats, setStats] = useState({});
  const [employees, setEmployees] = useState([]);
  const [branches, setBranches] = useState([]);
  const [loading, setLoading] = useState(true);
  const [refsLoaded, setRefsLoaded] = useState(false);

  const load = useCallback(async () => {
    setLoading(true);
    const params = Object.fromEntries(Object.entries(filters).filter(([, v]) => v));
    const [list, stat] = await Promise.all([listTasks(params), taskStats(params)]);
    setRows(list.items || []);
    setStats(stat || {});
    setLoading(false);
  }, [filters]);

  useEffect(() => { load(); }, [load]);

  useEffect(() => {
    Promise.all([
      listUsers(null, "active").then(setEmployees).catch(() => setEmployees([])),
      listBranches().then(setBranches).catch(() => setBranches([])),
    ]).finally(() => setRefsLoaded(true));
  }, []);

  return { filters, setFilters, rows, stats, employees, branches, loading, refsLoaded, reload: load };
};
